import { Helmet } from 'react-helmet';
import { ReindexSearchCollectionContainer } from '../components/reindex-search-collection.container';

export const ISConfigReindexSearchCollection: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Is config - Search Indexes</title>
      </Helmet>
      <ReindexSearchCollectionContainer />
    </>
  );
};
